module.exports = __webpack_public_path__ + "img/slide3.8f6960af.jpg";